import { DataSource, Layout, Table, } from "@mcleod/components";

export abstract class AutogenLayoutCarriersForAssignment extends Layout {
    sourceCarriersForAssignment: DataSource;
    table1: Table;
}
